export enum SubscriptionModule {
  BDO = 'BDO',
  WEIGHING = 'WEIGHING',
  AUTOMATION = 'AUTOMATION',
  CAMERAS = 'CAMERAS',
  REGISTRATION_NUMBER_RECOGNITION = 'REGISTRATION_NUMBER_RECOGNITION',
  MANUAL_ANPR = 'MANUAL_ANPR',
  SPY = 'SPY',
  ACCESS_CONTROL = 'ACCESS_CONTROL',
  RFID_SERVICE = 'RFID_SERVICE',
  ACCESS_CONTROL_ARRIVAL_NOTIFICATION = 'ACCESS_CONTROL_ARRIVAL_NOTIFICATION',
  CONTAINERS = 'CONTAINERS',
  VEHICLE_OVERLOAD_CONTROL = 'VEHICLE_OVERLOAD_CONTROL',
  QR_ACCESS_CONTROL = 'QR_ACCESS_CONTROL',
  BALANCE_REPORTS = 'BALANCE_REPORTS',
  ACCESS_CONTROL_ARRIVAL_NOTIFICATION_CALENDAR_VIEW = 'ACCESS_CONTROL_ARRIVAL_NOTIFICATION_CALENDAR_VIEW',
  CUSTOM_RECEIPTS_TEMPLATES = 'CUSTOM_RECEIPTS_TEMPLATES',
  PRODUCT_ANALYSIS = 'PRODUCT_ANALYSIS',
}
